export function extractingContent(message: string): string {
  const virtualNode = document.createElement("div");
  virtualNode.innerHTML = message;
  removeScripts(virtualNode);
  removeOlderEmails(virtualNode);
  removeBaseURLAlterations(virtualNode);
  const smRootContentSelector = ":scope > meta + style + .panel .content";
  const content = virtualNode.querySelector(smRootContentSelector) || virtualNode;
  removeStyle(content);
  return content.innerHTML;
}

function removeOlderEmails(htmlNode: HTMLElement) {
  removeForGmail(htmlNode);
  removeForIOS(htmlNode);
  removeForOutlook(htmlNode);
}

function removeForGmail(htmlNode: HTMLElement) {
  htmlNode.querySelectorAll(":scope > .gmail_quote:last-child").forEach((it) => {
    if (
      it.previousSibling &&
      it.previousSibling["tagName"] &&
      it.previousSibling["tagName"].toLowerCase() === "br"
    )
      it.previousSibling.parentNode.removeChild(it.previousSibling);
    it.remove();
  });
}

function removeForIOS(htmlNode: HTMLElement) {
  htmlNode.querySelectorAll(':scope > div:last-child > blockquote[type="cite"]').forEach((it) => {
    if (
      it.previousSibling &&
      it.previousSibling["tagName"] &&
      it.previousSibling["tagName"].toLowerCase() === "div" &&
      it.previousSibling["dir"] &&
      it.previousSibling["dir"].toLowerCase() === "ltr"
    )
      it.previousSibling.parentNode.removeChild(it.previousSibling);
    it.remove();
  });
}

function removeForOutlook(htmlNode: HTMLElement) {
  htmlNode
    .querySelectorAll(':scope > meta + meta[name="Generator"] + style + .WordSection1')
    .forEach((it) => {
      const customStyleNode = htmlNode.querySelector(
        ':scope > meta + meta[name="Generator"] + style'
      );
      if (customStyleNode) it.parentNode.removeChild(customStyleNode);
      removeNodeAndEverythingAfter(
        it.querySelector(':scope > div[style*="border:none;border-top:solid"]')
      );
    });
  htmlNode
    .querySelectorAll(':scope > meta + meta[name="Generator"] + .WordSection1')
    .forEach((it) => {
      removeNodeAndEverythingAfter(
        it.querySelector(':scope > div[style*="border:none;border-top:solid"]')
      );
    });
}

function removeNodeAndEverythingAfter(htmlNode: Element) {
  if (htmlNode) {
    while (htmlNode.nextSibling) {
      htmlNode.parentNode.removeChild(htmlNode.nextSibling);
    }
    htmlNode.remove();
  }
}

function removeScripts(htmlNode: HTMLElement) {
  htmlNode.querySelectorAll("script").forEach((it) => it.remove());
}

function removeBaseURLAlterations(htmlNode: HTMLElement) {
  htmlNode.querySelectorAll("base").forEach((it) => it.remove());
  ["href", "src"].forEach((attr) =>
    htmlNode.querySelectorAll(`[${attr}]`).forEach((it) => {
      const url = it.getAttribute(attr);
      if (!url.startsWith("https://") || !url.startsWith("http://")) {
        it.removeAttribute(attr);
      }
    })
  );
}

function removeStyle(htmlNode: Element) {
  htmlNode.querySelectorAll("style").forEach((it) => it.remove());
  htmlNode.querySelectorAll("[style]").forEach((it) => it.removeAttribute("style"));
}
